import { render, staticRenderFns } from "./HorizontalCardScroller.vue?vue&type=template&id=90dc3328&scoped=true&"
import script from "./HorizontalCardScroller.vue?vue&type=script&lang=js&"
export * from "./HorizontalCardScroller.vue?vue&type=script&lang=js&"
import style0 from "./HorizontalCardScroller.vue?vue&type=style&index=0&id=90dc3328&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90dc3328",
  null
  
)

export default component.exports